function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13 4.545v6.682A1.773 1.773 0 0111.227 13H2.773A1.773 1.773 0 011 11.227V4.545h12zM4.131 8.91a.682.682 0 100 1.363.682.682 0 000-1.363zm2.867 0a.682.682 0 100 1.363.682.682 0 000-1.363zM4.13 6.182a.682.682 0 100 1.364.682.682 0 000-1.364zm2.867 0a.682.682 0 100 1.364.682.682 0 000-1.364zm2.866 0a.682.682 0 100 1.364.682.682 0 000-1.364zM11.227 1A1.773 1.773 0 0113 2.773v.954H1v-.954A1.773 1.773 0 012.773 1h8.454z",
  fill: "currentColor"
});

var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgCalendar;